// next
import NextLink from 'next/link';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack } from '@mui/material';
// routes
import { PATH_PAGE } from 'src/routes/paths';
// components
import Logo from 'src/components/Logo';
import SocialsButton from 'src/components/SocialsButton';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'ATC',
    children: [
      { name: 'About Us', href: PATH_PAGE.about },
      { name: 'Contact Us', href: PATH_PAGE.contact },
      { name: 'FAQ’s', href: PATH_PAGE.faqs },
    ],
  },
  {
    headline: 'Legal',
    children: [
      // { name: 'Compatible Devices', href: '/page/compatible_devices' },
      { name: 'Privacy Policy', href: '/page/legal-and-privacy' },
    ],
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const today = new Date()
  const year = today.getFullYear();
  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'left', md: 'space-between' }}
          sx={{ textAlign: { xs: 'left', md: 'left' } }}
          spacing={2}
        >
          <Grid item xs={12} md={3}>
            <Box sx={{ mb: { md: 1, xs: 2 } }}>
              <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
            </Box>
            <Typography variant="body2" sx={{ pr: { md: 5 }, mb: { xs: 4 } }}>
            A complete end-to-end asset management system that incorporates Bar Codes, QR inventory codes, GPS, RFID and cloud-based software to allow inventory management professionals to track and manage equipment or any asset, residential customers to manage their valuables, commercial and industrial clients to manage their buildings, maintenance and resources.
            </Typography>
          </Grid>

          {LINKS.map((list) => (
            <Grid key={list.headline} item xs={6} md={3}>
              <Box sx={{ my: { md: 1 } }}>
                <Typography sx={{ mb: 2 }} component="p" variant="overline">
                  {list.headline}
                </Typography>
                {list.children.map((link) => (
                  <Box sx={{ my: 2 }} key={link.name}>
                    <NextLink href={link.href} passHref>
                      <Link color="inherit" variant="body2" sx={{ display: 'block' }}>
                        {link.name}
                      </Link>
                    </NextLink>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
          <Grid item md={3}>
            <Typography sx={{ ml: { md: 1, xs: 0 }, mb: { md: 2, xs: 0 }, mt: { md: 1 } }} component="p" variant="overline">
              Follow Us:
            </Typography>
            <Box>
              <Stack
                direction="row"
                justifyContent={'flex-start'}
                sx={{ mt: 0, pl: 0, mb: { xs: 5, md: 0 } }}
              >
                <SocialsButton links={{
                  linkedin: 'https://www.linkedin.com/company/asset-track-for-cloud-llc',
                  facebook: 'https://www.facebook.com/assettrackforcloud',
                  google: 'https://assettrackforcloud.business.site/'
                }} sx={{ mr: 0.8, mt: { md: 0, xs: 1 } }} />
              </Stack>
            </Box>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: { md: 4, xs: 0 },
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'center' },
          }}
        >
          © {year}. All rights reserved
          <a href="https://assettrackforcloud.com/"> Asset Track for Cloud</a>
        </Typography>
      </Container>
    </RootStyle>
  );
}
